import { getNumber, lazyWithRetry, throw404Error } from '@tyro/core';
import { DocEditIcon } from '@tyro/icons';
import { type NavObjectFunction, NavObjectType } from '@tyro/router/types';
import { getInfoRequestFormList } from './api/form-list';
import { getInfoRequestFormSetupDetails } from './api/form-setup';
import { InfoRequestCountLabel } from './components/info-request-count';

const InfoRequestFormList = lazyWithRetry(() => import('./pages/index'));
const InfoRequestFormView = lazyWithRetry(() => import('./pages/view'));

export const getRoutes: NavObjectFunction = (t) => [
  {
    type: NavObjectType.Category,
    title: t('navigation:general.title'),
    children: [
      {
        type: NavObjectType.RootLink,
        path: '/info-requests',
        title: t('navigation:general.infoRequests'),
        icon: <DocEditIcon />,
        info: <InfoRequestCountLabel />,
        children: [
          {
            type: NavObjectType.NonMenuLink,
            index: true,
            element: <InfoRequestFormList />,
            loader: () => getInfoRequestFormList({}),
          },
          {
            type: NavObjectType.NonMenuLink,
            path: 'view',
            element: <InfoRequestFormView />,
            loader: ({ request }) => {
              const url = new URL(request.url);
              const provider = url.searchParams.get('provider');
              const forPartyId = url.searchParams.get('forPartyId');
              const objectId = url.searchParams.get('objectId');
              const optionalResponderId = getNumber(
                url.searchParams.get('responderId'),
              );

              if (!provider) {
                return throw404Error();
              }

              return getInfoRequestFormSetupDetails({
                id: {
                  provider,
                  forPartyId,
                  objectId: Number(objectId),
                  optionalResponderId,
                },
              });
            },
          },
        ],
      },
    ],
  },
];
